








import {
  Vue,
  Component,
} from "@/shared/vuepack";

@Component({
  components: {}
})
export default class SettingsHeader extends Vue {
  get headerCopy (): string {
    return "Settings";
  }
}
